// API Service for Twilio SMS and Stripe Payments
// These endpoints are handled by Vercel serverless functions

const API_BASE = '/api';

/**
 * Send contract link via SMS using Twilio
 */
export async function sendContractSMS({ phoneNumber, contractId, clientName, artistName, customMessage }) {
  try {
    const response = await fetch(`${API_BASE}/send-sms`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        phoneNumber,
        contractId,
        clientName,
        artistName,
        message: customMessage,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to send SMS');
    }

    return data;
  } catch (error) {
    console.error('Error sending SMS:', error);
    throw error;
  }
}

/**
 * Create a Stripe payment link for contract deposit
 */
export async function createPaymentLink({ contractId, artistName, packageName, eventDate, depositAmount, clientEmail }) {
  try {
    const response = await fetch(`${API_BASE}/create-payment-link`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        contractId,
        artistName,
        packageName,
        eventDate,
        depositAmount,
        clientEmail,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to create payment link');
    }

    return data;
  } catch (error) {
    console.error('Error creating payment link:', error);
    throw error;
  }
}
